import { render, staticRenderFns } from "./KettleSetting.vue?vue&type=template&id=3683f922&scoped=true&"
import script from "./KettleSetting.vue?vue&type=script&lang=js&"
export * from "./KettleSetting.vue?vue&type=script&lang=js&"
import style0 from "./KettleSetting.vue?vue&type=style&index=0&id=3683f922&prod&lang=scss&scoped=true&"
import style1 from "./KettleSetting.vue?vue&type=style&index=1&id=3683f922&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3683f922",
  null
  
)

export default component.exports